import React, { useEffect, useState } from "react";
import { Link, Link as LinkRRD, useParams } from "react-router-dom";

import { Breadcrumbs, Button, Card, Paper, Typography } from "@mui/material";
import { Box, display, minWidth, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import LoadingUI from "../../comman/LoadingUI";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { dateFormatStartFun } from "../../helper/dateConverter";
import Body from "../../layout/Body";

import { allDeviceInfoAction } from "../../redux/toolkit/users/deviceInfo";
import { useStyles } from "../../theme/theme";
import { min } from "lodash";
import { userFromSameDeaviceAction } from "../../redux/toolkit/users/userFromSameDevice";
import { vi } from "date-fns/locale";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/admin"
      >
        User
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/devices-info"
      >
        Device Info
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      User
    </Typography>
  </Stack>
);

const UserFromSameDevice = () => {
  const dispatch = useDispatch();
//   const id  = useParams()?.id;
  const { visitorId } = useParams();

  const usreFromsameDevice = useSelector((state) => state.userFormSameDevice);
  let { data, loading, total, message, status } = usreFromsameDevice;

  console.log("++++++++++++total+++++++++++", total);

  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const classes = useStyles();
  const [snack, setSnack] = useState(false);

  const adminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      maxWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },

    {
      field: "visitorId",
      headerName: "Visitor Id",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "appId",
      headerName: "App Id",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "p_user_id",
      headerName: "P User Id",
      filterable: false,
      flex: 1,
      maxWidth: 400,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "userId",
      headerName: "User Id",
      filterable: false,
      flex: 1,
      minWidth: 250,

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.userId}</Typography>;
      },
    },

    {
      field: "email",
      headerName: "Email",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.email}</Typography>;
      },
    },

  

    {
      field: "clicked_on",
      headerName: "Clicked On",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {moment(params?.row?.clicked_on)
              .local()
              .format("DD-MM-YYYY,h:mm:ss a")}
          </Typography>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(
      userFromSameDeaviceAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
        visitorId: visitorId
      })
    );

  }, [pageState.page, pageState.pageSize]);



  return (
    <>
      <Helmet>
        <title>Real Opinion Admin | User</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />

      <Body>
        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={adminColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              // loading={loading ? <Loader /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>
      </Body>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default UserFromSameDevice;
